"use client"

import { usePathname } from "next/navigation"
import styled from "styled-components"
import {
  HEADER_HEIGHT_D,
  HEADER_HEIGHT_M,
  HEADER_HEIGHT_SMALL_LAPTOP,
} from "theme/shared"

// --- Styles ---
const StyledPageWrapper = styled.div<{ $isModelsRoute: boolean }>`
  display: flex;
  padding-top: ${HEADER_HEIGHT_M}px;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  overflow: hidden;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: ${HEADER_HEIGHT_SMALL_LAPTOP}px;
  }
  ${(p) => p.theme.breakpoints.up("smallLaptop")} {
    padding-top: ${(p) =>
      p.$isModelsRoute ? HEADER_HEIGHT_D : HEADER_HEIGHT_SMALL_LAPTOP}px;
  }
`

const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname()
  const isModelsRoute = pathname?.startsWith("/models") ?? false

  return (
    <StyledPageWrapper $isModelsRoute={isModelsRoute}>
      {children}
    </StyledPageWrapper>
  )
}

export default PageWrapper
